import { render, staticRenderFns } from "./BaseSwitch.vue?vue&type=template&id=cf998588&scoped=true&"
import script from "./BaseSwitch.vue?vue&type=script&lang=js&"
export * from "./BaseSwitch.vue?vue&type=script&lang=js&"
import style0 from "./BaseSwitch.vue?vue&type=style&index=0&id=cf998588&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf998588",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\invoicingfullversion2\\invoicing_app\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cf998588')) {
      api.createRecord('cf998588', component.options)
    } else {
      api.reload('cf998588', component.options)
    }
    module.hot.accept("./BaseSwitch.vue?vue&type=template&id=cf998588&scoped=true&", function () {
      api.rerender('cf998588', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/base/BaseSwitch.vue"
export default component.exports